import styled from "styled-components";

import QRCode from "react-qr-code";

export const QrCode = styled(QRCode)`
  border: 5px solid white;
  border-radius: 5px;
  height: 100%;
  margin: 1rem 0;
  max-height: 175px;
  max-width: 175px;
  min-width: 135px;
  width: 100%;
`;
